export const MARKETING_READ_PERMISSION = "marketing:read";
export const MARKETING_EXPORT_PERMISSION = "marketing:export";

export const getPermissions = user => (
  Array.isArray(user?.permissions)
    ? user.permissions.filter(permission => typeof permission === "string")
    : []
);

export const isFullAdmin = user => user?.is_admin === true;

export const hasPermission = (user, permission) => (
  isFullAdmin(user) || getPermissions(user).includes(permission)
);

export const canReadMarketing = user => (
  hasPermission(user, MARKETING_READ_PERMISSION)
);

export const canExportMarketing = user => (
  hasPermission(user, MARKETING_EXPORT_PERMISSION)
);

export const hasBackofficeAccess = user => (
  isFullAdmin(user) || canReadMarketing(user)
);

export const getDefaultBackofficePath = user => (
  isFullAdmin(user) ? "/dashboard" : canReadMarketing(user) ? "/marketing" : "/access-denied"
);
